import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { Routes } from './components/routes';
import { ScrollTop } from './components/srollTop';

function App() {
  return (
    <Router>
      <ScrollTop />
      <Routes />
    </Router>
  );
}

export default App;
